import { useEffect } from 'react';
import { useTenantId } from '@/hooks/useTenantId';
import { registerFcmToken } from '@/lib/fcm';

/**
 * Keeps this device's FCM topic membership aligned with the citizen's
 * selected city. Citizens have no server-side tenant, so announcement/
 * emergency topic subscriptions are keyed per device token — the api
 * subscribes the token to the city sent at registration. Re-registering
 * is idempotent, and re-homing to a different city unsubscribes the old
 * one server-side. Fires only when the resolved city changes.
 */
export function FcmTenantSync(): null {
  const tenantId = useTenantId();
  useEffect(() => {
    // Re-register / re-home topics automatically ONLY when the user has
    // already granted permission. Prompting from here never worked on
    // Safari/iOS — see registerFcmToken.
    if (tenantId) void registerFcmToken(tenantId);
  }, [tenantId]);
  return null;
}
